module.exports = __webpack_public_path__ + "static/img/StimulusModeBlue.6f6ff23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StimulusModeBlue.png
// module id = spJe
// module chunks = 1